jQuery(document).ready(function($){
	// SPLIDE FOR HERO CAROUSEL
	 $(document).ready(function(){
	 	console.log('hero-slider fired');
	 		var splide = new Splide( '.hero-slider', {
	 			type: 'loop',
	 			perMove: 1,
	 			autoWidth: false,
				autoplay: true,
				pauseOnHover: true,
				interval: 5000,
	 			pagination: false,
	 			focus: 'center',
	 			trimSpace: false,
	 			gap: 50,
	 			perPage: 1,
	 			start: 0,
				breakpoints: {
						640: {
							destroy: true,
						},
				}
	 		} ).mount();
	 });
	 
	 // close mobile menu on anchor clicks
	 $(document).ready(function(){
		 $('.off-canvas a').on('click', function() {
		     $('.off-canvas').foundation('close');
		 });
	 });
	 
  	// add the gif src so it starts at the beginning of each opening screen
  	$( document ).ready(function() {
		 function callback(entries) {
		    for (let i = 0; i < entries.length; i++ ) {
		     entries[i].target.src = (entries[i].isIntersecting) ? entries[i].target.getAttribute('data-src') : "";
		    }
		 }
		 const gifs = document.querySelectorAll('.gif');
		 const observer = new IntersectionObserver(callback);
		 for (let i = 0; i < gifs.length; i++) {
		   observer.observe(gifs[i]);
		 }
	  });
	 
 	//toggle class when footer in view
 	$( document ).ready(function() {

		var controller = new ScrollMagic.Controller();

		var footerScene = new ScrollMagic.Scene({
			triggerElement: '#the-footer',
			offset: 200
		})
	
		.addTo(controller);

			footerScene.on('enter', function (e) {
    
			    setTimeout(function () {
			        e.currentTarget.triggerElement().classList.add('dance-chicken'); 
			    }, 500);
			    setTimeout(function () {
			        e.currentTarget.triggerElement().classList.remove('dance-chicken'); 
			    }, 2100);
    
			});

 	});
	 
	 //set the cookie after first visit + hide opening screen after 2 seconds
	  $( document ).ready(function() {
	      setTimeout(function(){
	          Cookies.set('log_first_visit', 'true');
			  $('#opening-screen').addClass('viewed');
	      },2600); 
	  });
	  
     // Hide Header on on scroll down
     var didScroll;
     var lastScrollTop = 0;
     var delta = 5;
     var navbarHeight = 80;

     $(window).scroll(function(event){
         didScroll = true;
     });

     setInterval(function() {
         if (didScroll) {
             hasScrolled();
             didScroll = false;
         }
     }, 250);

     function hasScrolled() {
         var st = $(this).scrollTop();

         // Make sure they scroll more than delta
         if(Math.abs(lastScrollTop - st) <= delta)
             return;

         if(st > navbarHeight+300){
             $('.header').addClass('has-bg');
         }else{
             $('.header').removeClass('has-bg');
         }

         // If they scrolled down and are past the navbar, add class .nav-up.
         // This is necessary so you never see what is "behind" the navbar.
         if (st > lastScrollTop && st > navbarHeight){
             // Scroll Down
             $('.header').addClass('tucked');
         } else {
             // Scroll Up
             if(st + $(window).height() < $(document).height()) {
                 $('.header').removeClass('tucked');
             }
         }

         lastScrollTop = st;
     }
	 
 });